import React, {useCallback, useEffect, useState} from 'react';
import {observer} from "mobx-react";
import {GamesOpenSessionsContainerBox} from "./boxes/component-container/games-open-sessions-container.box";
import {
    GamesOpenSessionsRecordsContainerComponent
} from "./games-open-sessions-records-container.component";
import {withServices} from "../../react-hooks/with-services";
import {ComponentServicesPick} from "../../services/component-services-pick";
import {IGameOpenSessionViewModel} from "../../services/games-open-sessions/games-open-session.service.interface";
import {reaction} from "mobx";
import {LoadingDotsComponent} from "../../basic-components/loading-dots/loading-dots.component";
import {useServices} from "../../react-hooks/use-services.hook";


interface GamesOpenSessionsComponentProps extends ComponentServicesPick<'openSessions' | 'gameRunner'> {
}

export const ComponentBody: React.FC<GamesOpenSessionsComponentProps> = observer((props) => {
    const services = useServices();
    const [openSessions, setOpenSessions] = useState<IGameOpenSessionViewModel[] | null>(null);
    const [isLoading, setIsLoading] = useState(true);

    const loadOpenSessions = useCallback(() => {
        setIsLoading(true);
        props.openSessions.getAllOpenSessions().then(os => {
            setOpenSessions(os);
        }).finally(() => {
            setIsLoading(false);
        })
    }, [props.openSessions])

    useEffect(() => {
        if(!openSessions) { //this is the first time
            loadOpenSessions();
        }

    }, [openSessions, loadOpenSessions]);

    useEffect(() => {
        const reactionDispose = reaction(() => props.gameRunner.currentRunningGame,
            (currentRunningGame) => {
                if(!currentRunningGame) { //means the game was just closed
                    loadOpenSessions(); //we reload the open sessions
                }
            });
        return () => {
            reactionDispose();
        }
    }, [loadOpenSessions, props.gameRunner]);


    const renderContent = () => {
        if(isLoading || !openSessions || !services.user.isAuthorized) {
            return (
                <LoadingDotsComponent/>
            )
        }

        if(openSessions.length === 0) {
            return (
                <div>
                    {services.translation.translate('OPEN_BETS_NO_RECORDS')}
                </div>
            )
        }

        return ( <GamesOpenSessionsRecordsContainerComponent openSessions={openSessions}/>);
    }


    return (
        <GamesOpenSessionsContainerBox>
            {renderContent()}
        </GamesOpenSessionsContainerBox>
    )
})

export const GamesOpenSessionsComponent = withServices(ComponentBody, ['openSessions', 'gameRunner']);